<template>
  <form @submit.prevent="">
    <ZDialog :show="isVisible">
      <template #header>
        <div class="custom-header">
          <div class="row">
            <div class="col-md-11">
              <h4 class="modal-title">
                {{ title }}
              </h4>
            </div>
            <div class="col-md-1">
              <a href="#" class="custom-close" @click="close">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
      <template #body>
        <RequestNotes />
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col-1">
            <span title="ids">{{ ids }}</span>
          </div>
          <div class="col"></div>
          <div class="col custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Okay</button>
          </div>
        </div>
      </template>
    </ZDialog>
  </form>
</template>
<script>
import { mapActions } from 'pinia'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import RequestNotes from '@/components/dashboard/elements/RequestNotes.vue'
export default {
  name: 'DialogBlock',
  components: {
    ZDialog,
    RequestNotes
  },
  props: {
    modelValue: Object
  },
  emits: ['close'],
  computed: {
    isVisible() {
      console.log('modelValue', {
        model: this.modelValue
      })
      return this.modelValue !== null
    },
    title() {
      let _title = 'Notes'
      return _title
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    cancel() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-textarea {
  height: 200px;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
.hostWrapper {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: auto;
  height: 600px;
}
</style>
